import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
export function WhatYouGet() {
  const items = ['The Complete 10-Minute Anti-Inflammatory Digital Guide.', 'The "Morning Mirror" Protocol to flush out overnight stiffness.', 'The "No-Chop" Grocery List for pain-free kitchen prep.', 'Fluid-Joint Breakfasts, Energizing Lunches, and 10-Minute Dinners.', 'The "Night-Cap" Tea Ritual to de-puff your body while you sleep.', 'The 3 "Inflammation Villains" hiding in your pantry right now.'];
  return <section className="bg-white py-6 px-4 md:px-8" data-id="element-182">
      <div className="max-w-2xl mx-auto" data-id="element-183">
        <FadeIn data-id="element-184">
          <h2 className="text-xl md:text-2xl font-bold text-forest mb-3 text-center" data-id="element-185">
            Everything Inside Your Guide
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-2" data-id="element-186">
          {items.map((item, index) => <FadeIn key={index} delay={0.08 * (index + 1)} data-id="element-187">
              <div className="flex items-start gap-2.5 p-3 rounded-lg border border-gray-100 bg-cream-dark h-full" data-id="element-188">
                <CheckCircle2 className="w-5 h-5 text-forest flex-shrink-0 mt-0.5" data-id="element-189" />
                <p className="text-sm md:text-base text-charcoal font-medium" data-id="element-190">
                  {item}
                </p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}